import React, { Component } from 'react';
import Toto from '../EnfantToto/EnfantToto'


class Maman extends Component {
    state = {
        messageMaman: null, 
        messageToto: null
    }

    ordreMaman = () => {
      this.setState({
          messageMaman: 'Vas ranger ta chambre'
      })
    }

    reponseToto = () => {
        this.setState({
            messageToto: 'oui maman'
      })
    }
    
    render(){
        return(
            <div className="text-center">
                
                <h1>Maman </h1>
                <button onClick={this.ordreMaman} className="btn btn-primary"> Ordre de la mère </button>
                <p className='h1 text-danger'>{this.state.messageMaman}</p>
                <hr />
                <Toto name='Toto' reponseToto={this.reponseToto} theState={this.state} />

            </div>
        )
    }
}

export default Maman